/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".select-magazine-dialog__description[_ngcontent-%COMP%]{line-height:1.2;padding-bottom:10px}"];
export { styles as styles };
